<div
  class="StarRating"
  [ngClass]="{
    'StarRating--row': direction === 'row',
    'StarRating--column': direction === 'column',
  }"
>
  <div class="StarRating__empty">
    @for (star of stars; track star) {
      <icon [name]="starIcon" [config]="iconConfig"> </icon>
    }

    <div
      class="StarRating__filled"
      [ngStyle]="{ width: starWidthRounded + '%' }"
    >
      @for (star of stars; track star) {
        <icon [name]="starFilledIcon || 'star_active'" [config]="iconConfig">
        </icon>
      }
    </div>

    <div
      class="StarRating__filled"
      [ngStyle]="{ width: starWidthRounded + '%' }"
    >
      @for (star of stars; track star) {
        <icon name="star_active" [config]="iconConfig"> </icon>
      }
    </div>
  </div>

  <p class="StarRating__text">
    {{ displayRating }} out of {{ numberOfStars }} stars
  </p>
</div>
